/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

import axios, { AxiosInstance } from 'axios'

export interface Pagination<Type> {
  totalDocs?: number
  limit?: number
  totalPages?: number
  page?: any
  pagingCounter?: any
  hasPrevPage?: boolean
  hasNextPage?: boolean
  prevPage?: any
  nextPage?: any
  docs: Type[]
}

export interface FilterPagination {
  page?: number
  limit?: number
}

type Config = {
  [key: string]: any;
  API_URL?: string;
  axios: AxiosInstance;
  axiosWithoutCredentials: AxiosInstance;
}

const config: Config = {
  axios: axios.create({
    withCredentials: true
  }),
  axiosWithoutCredentials: axios.create({
    withCredentials: false
  })
}

config.axios.interceptors.request.use(
  async interceptorConfig => {
    const accessToken = config.ACCESS_TOKEN

    interceptorConfig.headers = {
      ...interceptorConfig.headers,
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
    }

    return interceptorConfig
  },
  error => {
    return Promise.reject(error)
  })

export const setConfig = (a: string, b: any): any => {
  config[a] = b

  return b
}

export const getConfig = (): Config => config
